import { addons } from '@storybook/addons';
import { storybook_theme } from './theme';

addons.setConfig({
  theme: storybook_theme,
  enableShortcuts: false,
});
